//dependencias
import React, { Component } from 'react';

//componentes
import SeccionesAAction from './seccionesA'

class Index extends Component {

    render(){
        return(
            <div>
                <SeccionesAAction />
            </div>
        );
    }

}
export default Index;